module.exports = __webpack_public_path__ + "img/activities-1.293953ef.jpg";